// 持分くん: お客様の声スライダー（Next: VoiceSection の Swiper 設定を踏襲）
// Swiper は CDN(swiper-bundle) でグローバル読込済み。対象が無ければ no-op。
export function initVoiceSwiper() {
  const el = document.querySelector('.js-voiceSwiper');
  if (!el || typeof window.Swiper === 'undefined') return;

  new window.Swiper(el, {
    slidesPerView: 1.4,
    spaceBetween: 20,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    breakpoints: {
      768: { slidesPerView: 2.5, spaceBetween: 20, slidesOffsetBefore: 60, slidesOffsetAfter: 60 },
      1024: { slidesPerView: 3.3, spaceBetween: 20, slidesOffsetBefore: 60, slidesOffsetAfter: 60 },
    },
  });
}
